import React, { useEffect, useState } from 'react';
import MyReports from './Children/MyReports';
import ScheduleProWrapper from '../../../../../SmartSchedule/SchedulePro/ScheduleProWrapper';



const MyReportsWrapper = (props) => {
    const {themeSelected} = props
    return (
                <ScheduleProWrapper>
            <div className='container-fluid user-ss-wrapper p-3'>
                <MyReports themeSelected={themeSelected} />
            </div>
        </ScheduleProWrapper>
    )
}

export default MyReportsWrapper;